/**
 * Normalise une valeur en array itérable pour les constructeurs d'entités.
 * Gère les cas :
 * - null/undefined → []
 * - Array → tel quel
 * - Object (PHP associative array) → Object.values()
 * - Primitif (number/string — un ID brut) → [] (ignoré, pas un objet imbriqué)
 */
export function toArray(value: any): any[] {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'object') return Object.values(value);
    return [];
}

/**
 * Itère sur une collection d'entités et les instancie.
 * Gère les données imbriquées (objets), les arrays, les objets PHP,
 * et ignore les primitifs (IDs bruts du store plat).
 */
export function hydrateCollection<T>(
    data: any,
    EntityClass: new (obj: any) => T,
    target: T[]
): void {
    const items = toArray(data);
    for (const item of items) {
        if (item === null || item === undefined) continue;
        // Si c'est déjà une instance, garder tel quel
        if (item instanceof EntityClass) {
            target.push(item);
        } else if (typeof item === 'object') {
            // Objet — instancier
            target.push(new EntityClass(item));
        }
        // Primitif (number/string = ID brut) → ignoré
    }
}
